import { Avatar } from "@tokenterminal/core/ui/icon/Avatar"
import { Field } from "@tokenterminal/core/ui/input/Field"
import { type ProjectDetailsMeta } from "@tokenterminal/tt-types"
import {
  useExperimentalFlagEnabled,
  EXPERIMENTAL_FLAGS,
} from "hooks/useExperimentalFlags"
import Link from "next/link"
import { useMemo } from "react"
import { getProjectPageRoute } from "utils/getProjectPageRoute"
import { useProductsMeta } from "../hooks/useProductsMeta"

type ProductsProps = {
  projectSlug: ProjectDetailsMeta["slug"]
}

// TODO: Abstract this so that both Products and Similar Projects can use it
export const Products = ({ projectSlug }: ProductsProps) => {
  const { data: allProducts } = useProductsMeta()

  const { enabled: newProductPageEnabled, loading: newProductPageLoading } =
    useExperimentalFlagEnabled(EXPERIMENTAL_FLAGS.PRODUCT_PAGES_V1)

  const projectProducts = useMemo(
    () =>
      allProducts?.filter((product) => product.project_slug === projectSlug) ||
      [],
    [allProducts, projectSlug]
  )

  if (
    newProductPageLoading ||
    !newProductPageEnabled ||
    projectProducts.length === 0
  ) {
    return null
  }

  return (
    <Field label="Project Products">
      <div className="flex flex-col border border-solid border-border-default rounded-lg overflow-hidden">
        {projectProducts.map((product) => (
          <Link
            key={product.product_id}
            href={getProjectPageRoute({
              projectSlug,
              productId: product.product_id,
            })}
            className="flex items-center gap-2 p-2 text-sm hover:bg-neutral-950/5 dark:hover:bg-neutral-50/5 border-b border-solid border-border-default last:border-b-0"
          >
            <Avatar
              src={`https://static1.tokenterminal.com/${product.logo}`}
              className="w-4 h-4 rounded-full overflow-hidden"
            />
            <span>{product.product_name}</span>
          </Link>
        ))}
      </div>
    </Field>
  )
}
